/*if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
}*/

angular.module("pe4h").factory("LoadInterceptor", [
	"$q","$rootScope",
	function ($q, $rootScope) {
	    
		return {			
		    responseError: function (rejection) {
		        
			    if (rejection.status == -1 && rejection.data == null) {
			        //$rootScope.$broadcast("errorMessage", { msg: "Connection failed" });			        
                    //Use alert because html template can also fail to be fetched.
                    alert("Connection failed.");
			    }
			    return $q.reject(rejection);
			}	
		};
	}
]);